const SERVER_URL = 'https://body-monitor.gryp.dev';

export default {
	SERVER_URL,
	API_URL: `${SERVER_URL}/API`,
};
